import { Box, Typography, createStyles } from "@material-ui/core";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import React, { ComponentProps } from "react";
// NEW LOGO
import logo from "../../assets/netpeak-logo.jpg";
// OLD LOGO:
// import logo from "../../assets/logo.png";
import logos from "../../assets/logos.jpg";
const styles = () => {
	return createStyles({
		"@global": {
			"#root": {
				padding: "1px",
			},
			body: {
				backgroundSize: "cover",
				backgroundPosition: "bottom center",
			},
			"body, html": {
				padding: 0,
				margin: 0,
				height: "100%",
				width: "100%",
			},
		},
		container: {
			width: "800px",
			margin: "40px auto 40px auto",
			textAlign: "center",
			maxWidth: "calc(100% - 40px)",
			padding: "1px 0",
		},
		logo: {
			width: "200px",
			display: "block",
			margin: "0 auto 25px auto",
		},
		logos: {
			width: "100%",
			display: "block",
			margin: "0 auto 25px auto",
		},
	});
};

const mainPageTxt = {
	modelTxt: `Модел: Специализиран софтуер с изкуствен интелект за определяне на профила на идеалният клиент и генериране на рекламни текстове за дигитален маркетинг
Сериен номер: SPL-NTPKGRP-25-01
Производител: ЕС ПИ ЛИНК ЕООД`,
	footer001: `Софтуерът е закупен по АДБФП № BG16RFPR001-1.004-1600-C01 „Подобряване на производствения капацитет на НЕТПИК ГРУП ЕООД“ с финансовата подкрепа на Програма "Конкурентоспособност и иновации в предприятията" 2021-2027, BG16RFPR001-1.004 - Подкрепа за семейните предприятия, предприятията от творческите индустрии и занаятите, съфинансирана от Европейския съюз чрез Европейския фонд за регионално развитие.`,
	// footer002: `ПРОГРАМА ЗА РАЗВИТИЕ НА СЕЛСКИТЕ РАЙОНИ 2014-2020`,
	// footer003: `Европейски земеделски фонд за развитие на селските райони: Европа
	// 			инвестира в селските райони`,
};

// eslint-disable-next-line @typescript-eslint/naming-convention
function SignIn(props: ComponentProps<"body"> & WithStyles): JSX.Element {
	const { classes, children } = props;
	return (
		<Box className={classes.container}>
			<img src={logo} alt="logo" className={classes.logo} />
			<Box marginBottom={2}>
			<Typography variant="h4" style={{ marginBottom: 30}}>
				

			
НЕТПИК ГРУП ЕООД
				</Typography>
				<Typography variant="h6">
					Специализиран софтуер с изкуствен интелект за определяне на профила на идеалният клиент и генериране на рекламни текстове за дигитален маркетинг

				</Typography>
			</Box>
			<Box marginBottom={6}>
				<Typography>
					Сериен номер: SPL-NTPKGRP-25-01 |
					Производител: ЕС ПИ ЛИНК ЕООД
				</Typography>
			</Box>
			<Box
				sx={{
					width: "400px",
					maxWidth: "100%",
					marginLeft: "auto",
					marginRight: "auto",
					mb: 8,
				}}
			>
				{children}
			</Box>
			<Typography align="justify" variant="body1" style={{ marginBottom: 15 }}>
				{mainPageTxt.footer001}
			</Typography>
			<img src={logos} alt="logos" className={classes.logos} />
			{/* <Typography align="center" variant="body1" style={{ marginBottom: 15 }}>
				{mainPageTxt.footer002}
			</Typography>
			<Typography align="center" variant="body1" style={{ marginBottom: 15 }}>
				{mainPageTxt.footer003}
			</Typography> */}
		</Box>
	);
}

export default withStyles(styles)(SignIn);
